import { Chip } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

export const ItemRow = styled("div")(({ theme }) => ({
  display: "grid",
  gap: theme.spacing(2),
  gridTemplateColumns: "1fr",

  [theme.breakpoints.up("sm")]: {
    gridTemplateColumns: "15rem 1fr",
  },
}));

export const RowWrap = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const FulfillerWrap = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  flexWrap: "wrap",
}));

export const AvChip = styled(Chip)(() => ({
  ".MuiChip-avatar": { height: 20, width: 20 },
}));

export const StyledDiscount = styled("span")(({ theme }) => ({
  color: theme.palette.green.main,
  fontWeight: theme.typography.fontWeightBold,
}));
